module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-tab-wrapper",
    class: {
      isSwipe: _vm.isSwipe,
      'isGrid container fluid grid-list-lg px-0 pt-0': _vm.isGrid
    },
    style: (("min-height: " + _vm.minHeight + "px;"))
  }, [_c('div', {
    staticClass: "item-tabs",
    class: {
      'layout row wrap': _vm.isGrid
    }
  }, [_vm._t("itemTabs")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-846f8b9a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/itemTab.vue
// module id = 1805
// module chunks = 180